import { Component, OnInit, AfterViewInit, Input } from '@angular/core';

import {FormGroup, FormControl} from '@angular/forms';
import { DatePipe } from '@angular/common';
import { DateAdapter } from '@angular/material/core';

import { GetfridgeService } from 'src/app/services/getfridge.service';
import { GeteventsService } from 'src/app/services/getevents.service';

import { DataToGrafInactividad } from 'src/app/models/data-graf-inactividad';
import { DataGraficaInactividad } from 'src/app/models/data-grafica-inactividad';
import { DataGrafica } from 'src/app/models/data-grafica';
import { DataToGraf } from 'src/app/models/data-graf';
import { DataGraficaHistorico } from 'src/app/models/data-graf-historico';
import { DataGraficaInactividadHistorico } from 'src/app/models/data-grafica-inactividad-historico';



const datePipe = new DatePipe('en-US');

//Opciones radiobutton
const ocup: string = "OCUPACIÓN";
const porocup: string = "% OCUPACIÓN";
const mov: string  = "% MOVIMIENTO EN ESTANCIA";
const inac:  string = "% INACTIVIDAD EN REPOSO";
const nocup: string = "Nº CAMBIOS EN OCUPACIÓN";

const uso: string = "USO";
const movcocina: string = "% MOVIMIENTO EN LA COCINA";

//Opciones select
const disp1: string = "Disp1";
const disp2: string = "Disp2";
const disp3: string = "Disp3";
const disp1view: string = "Cama";
const disp2view: string = "Sillón";
const disp3view: string = "Frigorífico";

interface opcionSelect {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-tab-eventos',
  templateUrl: './tab-eventos.component.html',
  styleUrls: ['./tab-eventos.component.scss']
})
export class TabEventosComponent implements OnInit, AfterViewInit {

  DEBUG: boolean = false;

  //IMPUTS
  @Input() arrayUser:any;

  arrayEvents: any;
  arrayEventsHistorico: any;
  arrayFridge: any;
  arrayFridgeHistorico: any;
  
  grafica = null;
  data = {
    graficasOcupa:[
      { text: ocup, isDefault: true },
      { text: porocup, isDefault: false },
      { text: mov, isDefault: false },
      { text: inac,  isDefault: false },
      { text: nocup,  isDefault: false }
    ],
    graficasFridge:[
      { text: uso, isDefault: true },
      { text: movcocina, isDefault: false },
    ]
}


  verHistorico: boolean = false;

  //Arrays de datos de las gráfias
  arrayTemperatura: any = [];
  arrayHumedad: any = [];
  arrayIluminacion: any = [];

  dataChartArray = [];
  graficaSelect: string;
  flagDatos: boolean = false;
  flagDatosOption: boolean = false;
  flagPorcentOcupacion: boolean = false;
  flagCargaGrafica: boolean = true;
  
  dataToGraf: DataToGraf;
  dataToGrafInactividad: DataToGrafInactividad;
// graficas enviadas
  dataGrafica: DataGrafica;
  dataGraficaInactividad: DataGraficaInactividad;
  dataGraficaHistorico: DataGraficaHistorico;
  dataGraficaInactividadHistorico: DataGraficaInactividadHistorico;

  diasHistoricoForm = new FormControl(false); // checkBox

  // SELECT
  opcionesDisp: opcionSelect[] = [
    { value: disp1,     viewValue: disp1view},
    { value: disp2,     viewValue: disp2view},
    { value: disp3,     viewValue: disp3view}
  ];
  selectOpcion = this.opcionesDisp[0].value;
  selectedDisp = this.opcionesDisp[0].value;
  disp: string;
  flagFrigo: boolean = false;

  //FECHA
  time: string;
  timeIni: number;
  timeFin: number;

  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl()
  });

  rangeDay = new FormGroup({
    dayHist: new FormControl()
  });
  timeDayHist: number;


  diaComparacion: string;
  startDate: string;
  endDate: string;


  timeHistIni: number;
  timeHistFin: number;

  constructor(
    private getEventsService: GeteventsService,
    private getFridgeService: GetfridgeService,
    date: DateAdapter<Date>
  ) { 
      // Inicio de la semana en lunes
      date.getFirstDayOfWeek = () => 1;

      const today = new Date(); // Ahora
      const month = today.getUTCMonth();
      const year = today.getUTCFullYear();
      const day  = today.getUTCDate();
        // RANGO FECHA
      this.range = new FormGroup({
        start: new FormControl(new Date(year, month, day-1)),
        end: new FormControl(new Date(year, month, day))
      });

      // DIA HISTORICO
      this.rangeDay = new FormGroup({
        dayHist: new FormControl(new Date(year, month, day-1))
    
      });    
  }

  ngOnInit() {
    if(this.DEBUG){
      console.log("[1. TabEventosComponent] - ngOnInit");
      console.log("arrayUser:");
      console.log(this.arrayUser)
    }

        // ponemos por defecto la ocupacion
        this.verHistorico = false;
        this.graficaSelect = ocup;
        this.grafica = this.data.graficasOcupa.filter(this.filterDefaultSize)[0];
    
        // Select con el Dispositivo1
        this.disp = this.arrayUser.disp1;
    
    //Cargamos los valores por defecto de la gráfica
    this.valuesDefaults();
    
  }

  valuesDefaults(){
    // // ponemos por defecto la ocupacion
    // this.verHistorico = false;
    // this.graficaSelect = ocup;
    // this.grafica = this.data.graficasOcupa.filter(this.filterDefaultSize)[0];

    // // Select con el Dispositivo1
    // this.disp = this.arrayUser.disp1;

    //Fecha actual de 1 dia
    this.timeIni = this.range.value.start.getTime();
    this.timeFin = new Date().getTime();
    this.time = this.timeIni + '-' + this.timeFin;
    
    if(this.DEBUG){
      console.log(this.grafica);
      console.log(this.disp);
      console.log("valuesDefaults");
    }
    
    
    this.flagDatosOption = true;
  }

  private filterDefaultSize(element){
    return (element.isDefault == true);
  }

  ngAfterViewInit() {

  }

  onOptionradioSelected(grafica) {
    // Capturamos el cambio y cargamos una nueva gráfica
    this.graficaSelect = grafica.text;
    if(this.graficaSelect == ""){
      this.flagPorcentOcupacion = true;
    }
  } 


  onOptionSelected() {
    if(this.DEBUG){
      console.log('[SELECTOR]  onOptionSelected: ' + this.selectOpcion);
    }
    switch(this.selectOpcion) { 
      case "Disp1": { 
          // CARGAMOS LOS DATOS DEL DISPOSITIVO-1
          if(this.flagFrigo){
            this.graficaSelect = ocup;
            this.grafica = this.data.graficasOcupa.filter(this.filterDefaultSize)[0];
          }
          this.disp = this.arrayUser.disp1;
          this.flagFrigo = false;

        break; 
     } 
      case "Disp2": { 
          // CARGAMOS LOS DATOS DEL DISPOSITIVO-2
          if(this.flagFrigo){
            this.graficaSelect = ocup;
            this.grafica = this.data.graficasOcupa.filter(this.filterDefaultSize)[0];
          }
          this.disp = this.arrayUser.disp2;
          this.flagFrigo = false;
         break; 
      } 
      case "Disp3": { 
        // CARGAMOS LOS DATOS DEL DISPOSITIVO-3
        if(!this.flagFrigo){
          this.grafica = this.data.graficasFridge.filter(this.filterDefaultSize)[0];
        }
        this.graficaSelect = uso;
        this.disp = this.arrayUser.disp3;
        this.flagFrigo = true;
       break; 
    } 
      default: { 
        //statements; 
        break; 
      } 
    }
  }

  // SELECTOR DE FECHA
  dateSelected() { 
    let today = new Date(); 
    let todayString: string;
    // Rango de fechas Timestamp
    this.timeIni = this.range.value.start.getTime();
    this.timeFin = this.range.value.end.getTime();

    this.time = this.timeIni + '-' + this.timeFin;

    //Rango de fechas normal
    todayString = datePipe.transform(today, 'd MM YYY');
    this.startDate = datePipe.transform(this.timeIni, 'd MM YYY');
    this.endDate = datePipe.transform(this.timeFin, 'd MM YYY');

    if(todayString == this.endDate){
      this.timeFin = new Date().getTime();
    }

    if(this.DEBUG){
      console.log("Fecha Hoy: " + today);
      console.log("START: " + this.startDate);
      console.log("END: " + this.endDate);
    }

  }

  // SELECTOR DE DIA PARA COMPARACIÓN CON HISTORICO
  daySelected(){
    console.log("daySelected para comparar con historico");
    // milisegundos
    this.timeDayHist = this.rangeDay.value.dayHist.getTime();
    // Rango de fechas Timestamp
    this.timeIni = this.rangeDay.value.dayHist.getTime();
    this.timeFin = this.rangeDay.value.dayHist.getTime() + 86400000;

    // fecha normal
    this.diaComparacion = datePipe.transform(this.timeDayHist, 'd MM YYY');
    this.startDate = datePipe.transform(this.timeIni, 'd MM YYY');
    this.endDate = datePipe.transform(this.timeFin, 'd MM YYY');

    if(this.DEBUG){
      console.log("Dia comparación: " + this.diaComparacion);
      console.log("START: " + this.startDate + " " + this.timeIni) ;
      console.log("END: " + this.endDate + " " + this.timeFin) ;
    }
  }

  cargarGrafica(){
    // Limpiamos los datos
    this.dataGrafica = null;
    this.dataGraficaHistorico = null;
    this.dataGraficaInactividad = null;
    this.dataGraficaInactividadHistorico = null;
    this.flagCargaGrafica = false;
    console.log("CARGAR GRAFICA");
    console.log("dataGrafica: " + this.dataGrafica);
    console.log("dataGraficaHistorico: " + this.dataGraficaHistorico);
    console.log("dataGraficaInactividad: " + this.dataGraficaInactividad);
    console.log("dataGraficaInactividadHistorico: " + this.dataGraficaInactividadHistorico);

    this.flagCargaGrafica = false;

    if(this.timeIni == this.timeFin){
      this.timeFin = this.timeFin + 86400000; //Sumamos 24h
    }

    if (this.verHistorico){
      if(this.getHistoricoDias()){
      let diasHistorico: any = this.getHistoricoDias();

      this.timeHistFin = this.timeFin; // Fecha actual
      this.timeHistIni = this.timeHistFin - (diasHistorico*86400000); // Multimplicamos milisegundo por los días y se los restamos al dia de hoy

      this.startDate = datePipe.transform(this.timeHistIni, 'd MM YYY');
      this.endDate = datePipe.transform(this.timeHistFin, 'd MM YYY');
      }else{
        // advertencia rellenar campo
        alert("Por favor rellene el campo de dias para su comparación");
      }
    }


    //Grafica seleccionada
    if(this.DEBUG){
      console.log("CARGAR GRAFICA CON LAS OPCIONES MOSTRADAS");
      console.log("Dispositivo: " + this.disp);
      console.log("Tipo de Grafica: " + this.graficaSelect);
      console.log("timeIni: " + this.timeIni + " - " + datePipe.transform(this.timeIni, 'HH:mm d MM YYY'));
      console.log("timeFin: " + this.timeFin + " - " + datePipe.transform(this.timeFin, 'HH:mm  d MM YYY'));
      console.log("Dias Historico: " + this.getHistoricoDias());
      console.log("timeHistIni: " + this.timeHistIni + " - " + datePipe.transform(this.timeHistIni, 'HH:mm  d MM YYY'));
      console.log("timeHistFin: " + this.timeHistFin + " - " + datePipe.transform(this.timeHistFin, 'HH:mm  d MM YYY'));
    }

    if(this.flagFrigo){
      // Recuperamos los datos de Fridge
      console.log("Recuperamos los datos del Frigorifico");
      this.asyncMethodFridge(this.disp);
    }else{
      // Recuperamos los datos de Events
      this.asyncMethodEvents(this.disp);
      console.log("datos recuperados")
    }
    
  }

  // OBTENCION DE LOS DATOS FRIDGE SEGUN LA FECHA
  async asyncMethodFridge(disp: string) {
    // Rango seleccionado
    this.arrayFridge = await this.getFridgeService.getFridge(disp, this.timeIni, this.timeFin);

    if (this.verHistorico){
      // Rango historico para comparación
      this.arrayFridgeHistorico = await this.getFridgeService.getFridge(disp, this.timeHistIni, this.timeHistFin);
    }

    if (this.arrayFridge != undefined){
      if(this.arrayFridge.length == 0){
        alert("No hay datos del dispositivo seleccionado en el rango de fechas introducido");
      }else{
        // Cargamos los datos en las gráficas
        if(this.DEBUG){
          console.log(this.graficaSelect);
          console.log(this.disp);
        }

        switch(this.graficaSelect) { 
          case uso: {
            // USO DEL FRIGORIFICO POR HORA
            if(this.DEBUG){
              console.log("USO DEL FRIGORIFICO POR HORA");
              console.log(this.arrayFridge);
              console.log("USO DEL FRIGORIFICO POR HORA - HISTORICO");
              console.log(this.arrayFridgeHistorico);
            }

            this.crearGraficaUsoFrigorifico();
 
            if(this.DEBUG){
              console.log(this.dataGrafica);
            }

            this.flagDatos = true;

            break; 
          } 
          case movcocina: { 

            this.crearGraficaMovimientoCocina();

            if(this.DEBUG){
              console.log("MOVIMIENTO COCINA");
              console.log(this.dataGrafica);
              console.log("MOVIMIENTO COCINA - HISTORICO");
              console.log(this.dataGraficaHistorico);
            }

            this.flagDatos = true;
            break; 
          } 

        }
      }  
    }else{
      alert("No hay datos del dispositivo seleccionado en el rango de fechas introducido");
    }
    // this.flagCargaGrafica = true;
  }

  // OBTENCION DE LOS DATOS EVENTS SEGUN LA FECHA
  async asyncMethodEvents(disp: string) {
  
      this.arrayEvents = await this.getEventsService.getEvents(disp, this.timeIni, this.timeFin);
      if(this.verHistorico){
        this.arrayEventsHistorico = await this.getEventsService.getEvents(disp, this.timeHistIni, this.timeHistFin);
      }

      if(this.arrayEvents.length == 0){
        alert("No hay datos del dispositivo seleccionado en el rango de fechas introducido");
      }else{
          // Cargamos los datos en las gráficas
          if(this.DEBUG){
            console.log(this.graficaSelect);
            console.log(this.disp);
          }
        switch(this.graficaSelect) { 
          case ocup: { 
            // OCUPACIÓN LINEAL
            let ocupacionAux: any = [];
            let timestampAux: any = [];

            // limpiamos el otro dato de la gráfica de inactividad
            this.dataToGrafInactividad = {
              ocup: [],
              pir: [],
              timestamp: []
 
            };
            this.dataGraficaInactividad = {
              data: this.dataToGrafInactividad,
              timeIni: 0,
              timeFin: 0,
              tipoGrafica: ""
            }  

           for (let i = 0; i < this.arrayEvents.length; i++) {
             if(this.arrayEvents[i].cama1 != undefined){
               ocupacionAux.push(this.arrayEvents[i].cama1);
               timestampAux.push(this.arrayEvents[i].timestamp);
             }
           }

           this.dataToGraf = {
             data: ocupacionAux,
             timestamp: timestampAux

           };

           //rellenamos los datos a enviar a la gráfica;
           this.dataGrafica = {
             data: this.dataToGraf,
             timeIni: this.timeIni,
             timeFin: this.timeFin,
             tipoGrafica: this.graficaSelect
           }

           if(this.DEBUG){
             console.log(this.dataGrafica);
           }

            this.flagDatos = true;
            break; 
         } 
          case porocup: { 
             // % OCUPACIÓN
             let ocupacionAux: any = [];
             let timestampAux: any = [];

            // limpiamos el otro dato de la gráfica de inactividad
            this.dataToGrafInactividad = {
              ocup: [],
              pir: [],
              timestamp: []
 
            };
            this.dataGraficaInactividad = {
              data: this.dataToGrafInactividad,
              timeIni: 0,
              timeFin: 0,
              tipoGrafica: ""
            }  

            for (let i = 0; i < this.arrayEvents.length; i++) {
              if(this.arrayEvents[i].cama1 != undefined){
                ocupacionAux.push(this.arrayEvents[i].cama1);
                timestampAux.push(this.arrayEvents[i].timestamp);
              }
            }

            this.dataToGraf = {
              data: ocupacionAux,
              timestamp: timestampAux

            };

            //rellenamos los datos a enviar a la gráfica;
            this.dataGrafica = {
              data: this.dataToGraf,
              timeIni: this.timeIni,
              timeFin: this.timeFin,
              tipoGrafica: this.graficaSelect
            }

            if(this.DEBUG){
              console.log(this.dataGrafica);
            }
            // ************ % OCUPACIÓN HISTORICO ************
            if (this.verHistorico){   
              ocupacionAux = [];
              timestampAux = [];  

              for (let i = 0; i < this.arrayEventsHistorico.length; i++) {
                if(this.arrayEventsHistorico[i].cama1 != undefined){
                  ocupacionAux.push(this.arrayEventsHistorico[i].cama1);
                  timestampAux.push(this.arrayEventsHistorico[i].timestamp);
                }
              }
  
              this.dataToGraf = {
                data: ocupacionAux,
                timestamp: timestampAux
  
              };
  
              //rellenamos los datos a enviar a la gráfica;
              this.dataGraficaHistorico = {
                data: this.dataToGraf,
                timeIni: this.timeHistIni,
                timeFin: this.timeHistFin,
                tipoGrafica: this.graficaSelect
              }            
            }         

             this.flagDatos = true;
             break; 
          } 
          case mov: { 
            //MOVIMIENTO PIR=0
            let pirAux: any = [];
            let timestampAux: any = [];

            // limpiamos el otro dato de la gráfica de inactividad
            this.dataToGrafInactividad = {
              ocup: [],
              pir: [],
              timestamp: []
 
            };
            this.dataGraficaInactividad = {
              data: this.dataToGrafInactividad,
              timeIni: 0,
              timeFin: 0,
              tipoGrafica: ""
            }      

             for (let i = 0; i < this.arrayEvents.length; i++) {
              if(this.arrayEvents[i].pir != undefined){
                pirAux.push(this.arrayEvents[i].pir);
                timestampAux.push(this.arrayEvents[i].timestamp);
              }
            }

           this.dataToGraf = {
             data: pirAux,
             timestamp: timestampAux

           };
         
           //rellenamos los datos a enviar a la gráfica;
           this.dataGrafica = {
             data: this.dataToGraf,
             timeIni: this.timeIni,
             timeFin: this.timeFin,
             tipoGrafica: this.graficaSelect
           }

           if(this.DEBUG){
            console.log(this.dataGrafica);
          }

            // ************ % MOVIMIENTO ESTANCIA HISTORICO ************
            if (this.verHistorico){   
              pirAux = [];
              timestampAux = [];  

              for (let i = 0; i < this.arrayEventsHistorico.length; i++) {
                if(this.arrayEventsHistorico[i].cama1 != undefined){
                  pirAux.push(this.arrayEventsHistorico[i].pir);
                  timestampAux.push(this.arrayEventsHistorico[i].timestamp);
                }
              }
  
              this.dataToGraf = {
                data: pirAux,
                timestamp: timestampAux
  
              };
  
              //rellenamos los datos a enviar a la gráfica;
              this.dataGraficaHistorico = {
                data: this.dataToGraf,
                timeIni: this.timeHistIni,
                timeFin: this.timeHistFin,
                tipoGrafica: this.graficaSelect
              }            
            } 
          
            this.flagDatos = true;
            break; 
          } 
          case inac: {
            //% INACTIVIDAD EN REPOSO;  PIR=0 && OCUP = 1
            let pirnAux: any = [];
            let ocupAux: any = [];
            let timestampAux: any = [];

            // limpiamos el otro dato de las gráficas
            this.dataToGraf = {
              data: [],
              timestamp: []
 
            };
            this.dataGrafica = {
              data: this.dataToGraf,
              timeIni: 0,
              timeFin: 0,
              tipoGrafica: ""
            }

            for (let i = 0; i < this.arrayEvents.length; i++) {
             if(this.arrayEvents[i].pir != undefined && this.arrayEvents[i].cama1 != undefined){
              pirnAux.push(this.arrayEvents[i].pir);
              ocupAux.push(this.arrayEvents[i].cama1);
               timestampAux.push(this.arrayEvents[i].timestamp);
             }
           }

           this.dataToGrafInactividad = {
             ocup: ocupAux,
             pir: pirnAux,
             timestamp: timestampAux

           };
         
           //rellenamos los datos a enviar a la gráfica;
           this.dataGraficaInactividad = {
             data: this.dataToGrafInactividad,
             timeIni: this.timeIni,
             timeFin: this.timeFin,
             tipoGrafica: this.graficaSelect
           }

           if(this.DEBUG){
            console.log(this.dataGraficaInactividad);
          }

          console.log("Lanzamos grafica inactividad")
          this.flagDatos = true;
          
            break; 
         } 
         case nocup: {
            //Nº CAMBIOS EN OCUPACIÓN; 
            let ocupacionAux: any = [];
            let timestampAux: any = [];

            // limpiamos el otro dato de la gráfica de inactividad
            this.dataToGrafInactividad = {
              ocup: [],
              pir: [],
              timestamp: []
 
            };
            this.dataGraficaInactividad = {
              data: this.dataToGrafInactividad,
              timeIni: 0,
              timeFin: 0,
              tipoGrafica: ""
            }  

              for (let i = 0; i < this.arrayEvents.length; i++) {
               if(this.arrayEvents[i].cama1 != undefined){
                 ocupacionAux.push(this.arrayEvents[i].cama1);
                 timestampAux.push(this.arrayEvents[i].timestamp);
               }
             }
            
           this.dataToGraf = {
             data: ocupacionAux,
             timestamp: timestampAux

           };
         
           //rellenamos los datos a enviar a la gráfica;
           this.dataGrafica = {
             data: this.dataToGraf,
             timeIni: this.timeIni,
             timeFin: this.timeFin,
             tipoGrafica: this.graficaSelect
           }

           if(this.DEBUG){
            console.log(this.dataGrafica);
          }

            // ************ Nº CAMBIOS HISTORICO ************
            if (this.verHistorico){   
              ocupacionAux = [];
              timestampAux = [];  

              for (let i = 0; i < this.arrayEventsHistorico.length; i++) {
                if(this.arrayEventsHistorico[i].cama1 != undefined){
                  ocupacionAux.push(this.arrayEventsHistorico[i].cama1);
                  timestampAux.push(this.arrayEventsHistorico[i].timestamp);
                }
              }
  
              this.dataToGraf = {
                data: ocupacionAux,
                timestamp: timestampAux
  
              };
  
              //rellenamos los datos a enviar a la gráfica;
              this.dataGraficaHistorico = {
                data: this.dataToGraf,
                timeIni: this.timeHistIni,
                timeFin: this.timeHistFin,
                tipoGrafica: this.graficaSelect
              }            
            }           
            this.flagDatos = true;
          
            break; 
         } 
          default: { 
            //statements; 
            break; 
          } 
        }
          }
          // this.flagCargaGrafica = true;
          console.log("datos lanzados")
  }

  crearGraficaUsoFrigorifico(){
    //Nº USO DEL FRIGORIFICO ************
    let usoAux: any = [];
    let timestampAux: any = [];

    // limpiamos el otro dato de la gráfica de inactividad
    this.dataToGrafInactividad = {
      ocup: [],
      pir: [],
      timestamp: []
 
    };
    this.dataGraficaInactividad = {
      data: this.dataToGrafInactividad,
      timeIni: 0,
      timeFin: 0,
      tipoGrafica: ""
    }  

      for (let i = 0; i < this.arrayFridge.length; i++) {
       if(this.arrayFridge[i].frigo != undefined){
        usoAux.push(this.arrayFridge[i].frigo);
         timestampAux.push(this.arrayFridge[i].timestamp);
       }
     }
   
    this.dataToGraf = {
     data: usoAux,
     timestamp: timestampAux
    };
        //rellenamos los datos a enviar a la gráfica;
    this.dataGrafica = {
     data: this.dataToGraf,
     timeIni: this.timeIni,
     timeFin: this.timeFin,
     tipoGrafica: this.graficaSelect
    };

     //Nº USO DEL FRIGORIFICO HISTORICO ************
    if (this.verHistorico){
      usoAux = [];
      timestampAux = [];
    
      for (let i = 0; i < this.arrayFridgeHistorico.length; i++) {
      if(this.arrayFridgeHistorico[i].frigo != undefined){
        usoAux.push(this.arrayFridgeHistorico[i].frigo);
        timestampAux.push(this.arrayFridgeHistorico[i].timestamp);
        }
      }
  
      this.dataToGraf = {
        data: usoAux,
        timestamp: timestampAux
      };
      //rellenamos los datos a enviar a la gráfica;
      this.dataGraficaHistorico = {
      data: this.dataToGraf,
      timeIni: this.timeHistIni,
      timeFin: this.timeHistFin,
      tipoGrafica: this.graficaSelect
      };
    }
    // this.flagCargaGrafica = true;
  }

  crearGraficaMovimientoCocina(){
    //MOVIMIENTO EN LA COCINA PIR=1
    let pirAux: any = [];
    let timestampAux: any = [];

    // limpiamos el otro dato de la gráfica de inactividad
    this.dataToGrafInactividad = {
      ocup: [],
      pir: [],
      timestamp: []

    };
    this.dataGraficaInactividad = {
      data: this.dataToGrafInactividad,
      timeIni: 0,
      timeFin: 0,
      tipoGrafica: ""
    }      

     for (let i = 0; i < this.arrayFridge.length; i++) {
      if(this.arrayFridge[i].pir != undefined){
        pirAux.push(this.arrayFridge[i].pir);
        timestampAux.push(this.arrayFridge[i].timestamp);
      }
    }

   this.dataToGraf = {
     data: pirAux,
     timestamp: timestampAux

   };
 
   //rellenamos los datos a enviar a la gráfica;
   this.dataGrafica = {
     data: this.dataToGraf,
     timeIni: this.timeIni,
     timeFin: this.timeFin,
     tipoGrafica: this.graficaSelect
   }

   if(this.DEBUG){
    console.log(this.dataGrafica);
  }
     //MOVIMIENTO EN LA COCINA HISTORICO ************
     if (this.verHistorico){
      pirAux = [];
      timestampAux = [];
    
      for (let i = 0; i < this.arrayFridgeHistorico.length; i++) {
      if(this.arrayFridgeHistorico[i].pir != undefined){
        pirAux.push(this.arrayFridgeHistorico[i].pir);
        timestampAux.push(this.arrayFridgeHistorico[i].timestamp);
        }
      }
  
      this.dataToGraf = {
        data: pirAux,
        timestamp: timestampAux
      };
      //rellenamos los datos a enviar a la gráfica;
      this.dataGraficaHistorico = {
      data: this.dataToGraf,
      timeIni: this.timeHistIni,
      timeFin: this.timeHistFin,
      tipoGrafica: this.graficaSelect
      };
    }
    // this.flagCargaGrafica = true;

  }

  getHistoricoDias(){
    return this.diasHistoricoForm.value;
  }

  checkVerHistorico(){

    if(this.verHistorico){
      this.diasHistoricoForm.enable();

      // DIA HISTORICO
      const today = new Date(); // Ahora
      const month = today.getUTCMonth();
      const year = today.getUTCFullYear();
      const day  = today.getUTCDate();
      this.rangeDay = new FormGroup({
        dayHist: new FormControl(new Date(year, month, day-1))
    
      });

      this.valuesDefaults();

      this.timeFin = this.timeIni + 86400000;

    }else{
      this.diasHistoricoForm.disable();

      const today = new Date(); // Ahora
      const month = today.getUTCMonth();
      const year = today.getUTCFullYear();
      const day  = today.getUTCDate();
        // RANGO FECHA
      this.range = new FormGroup({
        start: new FormControl(new Date(year, month, day-1)),
        end: new FormControl(new Date(year, month, day))
      });

      this.valuesDefaults();
    }


  }

  clearData(){
    this.dataToGraf = {
      data: [],
      timestamp: []
     };
     this.dataGraficaHistorico = null;
    this.dataGraficaHistorico = {
      data: this.dataToGraf,
      timeIni: 0,
      timeFin: 0,
      tipoGrafica: ""
      };
  }
}




